const UNSPLASH = {
  hero: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1600&h=900&fit=crop&q=80',
  heroMobile: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&h=1200&fit=crop&q=80',

  services: {
    privateChef:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=1200&fit=crop',
    restaurantReservations:
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=1200&fit=crop',
    ivTherapy:
      'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&h=1200&fit=crop',
    airportTransfer:
      'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&h=1200&fit=crop',
    arrivalEvent:
      'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&h=1200&fit=crop',
    groceryDelivery:
      'https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=800&h=1200&fit=crop',
    massage:
      'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&h=1200&fit=crop',
    customRequest:
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=1200&fit=crop',
  },

  lifestyle: {
    luxuryInterior:
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop',
    poolside:
      'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=800&h=600&fit=crop',
    kitchen:
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop',
  },
};

export default UNSPLASH;
